export default __webpack_public_path__ + "static/media/error-outline.8101d04d.svg";